const apiKey = "97b4f0aa30bbf27f5c634a7c8f5d7918";

export default apiKey;
